'use strict';

exports.NoMoreReason = void 0;
(function (NoMoreReason) {
  /** 没数据了 */
  NoMoreReason[NoMoreReason["NoMoreData"] = 0] = "NoMoreData";
  /** X 天内没数据了 */
  NoMoreReason[NoMoreReason["NoMoreDataInXDays"] = 1] = "NoMoreDataInXDays";
})(exports.NoMoreReason || (exports.NoMoreReason = {}));
// 数据发送方
exports.MessageSender = void 0;
(function (MessageSender) {
  MessageSender[MessageSender["User"] = 1] = "User";
  MessageSender[MessageSender["Chatbot"] = 2] = "Chatbot";
  MessageSender[MessageSender["Agent"] = 3] = "Agent";
  MessageSender[MessageSender["TxBot"] = 4] = "TxBot";
})(exports.MessageSender || (exports.MessageSender = {}));
// 消息类型
exports.HistoryMsgType = void 0;
(function (HistoryMsgType) {
  HistoryMsgType[HistoryMsgType["Inhouse"] = 2] = "Inhouse";
  HistoryMsgType[HistoryMsgType["Chatbot"] = 3] = "Chatbot";
  HistoryMsgType[HistoryMsgType["TxBot"] = 4] = "TxBot";
  HistoryMsgType[HistoryMsgType["CustomChatbot"] = 5] = "CustomChatbot";
})(exports.HistoryMsgType || (exports.HistoryMsgType = {}));
exports.HistoryApiMethod = void 0;
(function (HistoryApiMethod) {
  HistoryApiMethod["GET"] = "get";
  HistoryApiMethod["POST"] = "post";
})(exports.HistoryApiMethod || (exports.HistoryApiMethod = {}));
// sf历史消息
exports.SfHistoryType = void 0;
(function (SfHistoryType) {
  // 文本
  SfHistoryType["TEXT"] = "TEXT";
  // 文件
  SfHistoryType["FILE"] = "FILE";
  // 图片
  SfHistoryType["IMG"] = "IMG";
  // 视频
  SfHistoryType["VID"] = "VID";
  // 订单
  SfHistoryType["ORDER"] = "ORDER";
  // 收到文本
  SfHistoryType["CHAT_MESSAGE"] = "ChatMessage";
  // 会话建立
  SfHistoryType["CHAT_ESTABLISHED"] = "ChatEstablished";
  // 客服关闭会话
  SfHistoryType["CHAT_ENDED"] = "ChatEnded";
  // 用户主动结束会话，历史消息中添加
  SfHistoryType["CHAT_END"] = "CHAT_END";
  // 切换客服
  SfHistoryType["CHAT_TRANSFER"] = "AgentDisconnect_ChatbotV2";
  SfHistoryType["AGENT_DISCONNECT"] = "AgentDisconnect";
  SfHistoryType["CHAT_REQUEST_FAIL"] = "ChatRequestFail";
})(exports.SfHistoryType || (exports.SfHistoryType = {}));
// inhouse历史消息
exports.InhouseHistoryType = void 0;
(function (InhouseHistoryType) {
  // 文本
  InhouseHistoryType["TEXT"] = "TEXT";
  // 文件
  InhouseHistoryType["FILE"] = "FILE";
  // 图片
  InhouseHistoryType["IMG"] = "IMG";
  // 视频
  InhouseHistoryType["VID"] = "VID";
  // 订单
  InhouseHistoryType["ORDER"] = "ORDER";
  InhouseHistoryType["CS_JOINED"] = "CS_JOINED";
  InhouseHistoryType["USER_CLOSE_SESSION"] = "USER_CLOSE_SESSION";
  InhouseHistoryType["CS_CLOSE_SESSION"] = "CS_CLOSE_SESSION";
  InhouseHistoryType["CHASING_USER_CLOSE_SESSION"] = "CHASING_USER_CLOSE_SESSION";
  InhouseHistoryType["CHASING_TIMEOUT_CLOSE_SESSION"] = "CHASING_TIMEOUT_CLOSE_SESSION";
  InhouseHistoryType["SESSION_CLOSE_TIMEOUT"] = "SESSION_CLOSE_TIMEOUT";
  InhouseHistoryType["TRANSFER_SESSION"] = "TRANSFER_SESSION";
})(exports.InhouseHistoryType || (exports.InhouseHistoryType = {}));
exports.TxBotMsgType = void 0;
(function (TxBotMsgType) {
  TxBotMsgType[TxBotMsgType["TxBotText"] = 1] = "TxBotText";
  TxBotMsgType[TxBotMsgType["Options"] = 14] = "Options";
  TxBotMsgType[TxBotMsgType["UserText"] = 15] = "UserText";
})(exports.TxBotMsgType || (exports.TxBotMsgType = {}));